/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import _map from 'lodash/map'
import _forEach from 'lodash/forEach'

export enum RechargeEnum {
  主播钱包 = 0,
  普通充值 = 1,
  币商充值 = 2,
}

export enum ChannelStatusEnum {
  不生效 = 0,
  生效 = 1,
}

export enum ChannelTypeEnum {
  官方 = 0,
  周卡 = 1,
  华为 = 2,
  第三方 = 3,
  薪资转金币 = 4,
}

export interface RedirectInfo {
  redirect_url: string
  redirect_param: {[key: string]: string}
  redirect_method: 'get' | 'post'
}

export interface ProductsListInterface {
  list: Array<any>
  coins: number
  last_coins_stage: number
  tickets: number
  status: number
  exchange_cnt: number
  remain_tm: number
  is_recharged: number
  before_recharged: number
  is_ra_customer: boolean
  exchange_tickets_ratio: number
  countries: Array<{
    code: number
    name: string
    flag: string
  }>
  default_country: {
    code: number
    name: string
    flag: string
  }
  is_union: number // 是否是公会主播
  recharge_version: 'v1' | 'v2' // 控制新版首充礼包AB文案
  is_first_recharge: boolean
  baseInfo?: {
    mid: number //	用户mid
    show_id: string //	用户展示ID
    avatar_url: string //	头像URL
    name: string // 用户昵称
    region_code: number
  }
  is_audit_ver?: boolean // 由服务端下发，不写入 initialState
  is_white_tag?: boolean
  has_third_pay?: boolean
  has_week_card: boolean
}

export enum LimitEnum {
  固定值 = 1,
  直播比例 = 2,
  直播流转比例 = 3,
}

export interface ProductItem {
  product_id: string
  price: number
  coins: number
  currency: string
}

interface InitialStateType {
  wallet?: Partial<ProductsListInterface>
  chips?: {
    chip_balance: number
    list: Array<{id: number; chips_amount: number; coins_price: number}>
  }
  agency?: any
  base?: {
    showGuide: boolean
    useNew: boolean
    showFirstRechargeGiftPack: boolean
  }
  recharge?: {
    first_charge_page_icon?: string
  }
  code_store?: {
    s_n: boolean
    list: Array<{
      id: string
      product_id: string
      pay_method_id: string
      coins: string
      amount: string
      currency: string
    }>
  }
  monthly_influence_info?: {
    activity_status: number
  }
}
const initialState: InitialStateType = {}
const initData: InitialStateType = {
  wallet: {
    list: [],
    last_coins_stage: 0,
    coins: 0,
    tickets: 0,
    status: 0,
    exchange_cnt: 0,
    remain_tm: 0,
    is_recharged: 0,
    before_recharged: 0,
    is_ra_customer: false,
    exchange_tickets_ratio: 0,
    countries: [],
    default_country: {
      code: 0,
      name: '',
      flag: '',
    },
    is_union: 0, // 是否是公会主播
    recharge_version: 'v1', // 控制新版首充礼包AB文案
    is_first_recharge: false,
    has_week_card: false,
  },
  chips: {
    chip_balance: 0,
    list: [],
  },
  agency: {
    banner_list: [],
  },
  base: {
    showGuide: false,
    useNew: false,
    showFirstRechargeGiftPack: false,
  },
  recharge: {},
  monthly_influence_info: {
    activity_status: 0,
  },
}

export const get_banners = createAsyncThunk(
  'newWallet/get_banners',
  async (params, store: any) => {
    const resp = await http.post('/live/room/get_merchant_banner_list', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data.list || []
  }
)
export const get_recharge_agency_list = createAsyncThunk(
  'newWallet/get_recharge_agency_list',
  async (params: any, store: any) => {
    const resp = await http.post('/live/pay/get_recharge_agency_list', {
      ...store.getState().env.deviceinfo,
      ...params,
      offset: 0,
      limit: 10,
    })
    return resp.data.data
  }
)
export const check_third_party_list_version = createAsyncThunk(
  'newWallet/check_third_party_list_version',
  async (params: any, store: any) => {
    const resp = await http.post('/live/pay/check_third_party_list_version', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data?.version
  }
)
export const getMyRechargeGroup = createAsyncThunk(
  'newWallet/getMyRechargeGroup',
  async (params, store: any) => {
    const resp = await http.post('/live/activity/sb_enter_info', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data
  }
)
export const createRechargeOrderV2 = createAsyncThunk(
  'newWallet/createRechargeOrderV2',
  async (
    params: {
      product_id: string
      pay_method_id: number
      from: string
      code: number
      source: string
    },
    store: any
  ) => {
    const resp = await http.post(
      '/live/pay/create_order_h5_v2',
      {
        ...store.getState().env.deviceinfo,
        mid: store.getState().env.deviceinfo.h_m,
        ...params,
      },
      {
        xcHideLog: true,
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

export const exchangeTickets = createAsyncThunk(
  'newWallet/exchangeTickets',
  async (param: {tickets: number}, store: any) => {
    const resp = await http.post('/live/user/exchange_tickets', {
      ...store.getState().env.deviceinfo,
      mid: store.getState().env.deviceinfo.h_m,
      ...param,
    })
    return resp.data
  }
)

export const exchangeChips = createAsyncThunk(
  'newWallet/exchangeChips',
  async (
    {product_id, from}: {product_id: number; from?: string},
    store: any
  ) => {
    const resp = await http.post('/gamestore/common/account_exchange_in', {
      ...store.getState().env.deviceinfo,
      product_id,
      from,
    })
    return resp.data
  }
)

export const getChipsInfo = createAsyncThunk(
  'newWallet/getChipsInfo',
  async (arg, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post(
      '/gamestore/common/account_info',
      store.getState().env.deviceinfo
    )
    return resp.data
  }
)

export const getChipsProductList = createAsyncThunk(
  'newWallet/getChipsProductList',
  async (arg, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post(
      '/gamestore/common/chips_products',
      store.getState().env.deviceinfo
    )
    return resp.data
  }
)

export const getProductsList = createAsyncThunk(
  'newWallet/getProductsList',
  async (param: any = {}, store: any) => {
    const dev = store.getState().env.deviceinfo
    const {from} = store.getState().env.otherInfo
    const resp = await http.post('/live/pay/get_products_list_v2', {
      ...dev,
      ...param,
      before_recharged: 1,
      from,
    })
    return {...resp.data.data}
  }
)

export const getProductsList3 = createAsyncThunk(
  'newWallet/getProductsList3',
  async (param: any = {}, store: any) => {
    const dev = store.getState().env.deviceinfo
    const resp = await http.post('/live/pay/get_products_list_v3', {
      ...dev,
      ...param,
      before_r: 1,
    })
    return {...resp.data.data}
  }
)
export const getRechargeBonus = createAsyncThunk(
  'newWallet/getRechargeBonus',
  async (arg, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/activity/recharge_bonus', {
      ...store.getState().env.deviceinfo,
      mid: store.getState().env.deviceinfo.h_m,
    })
    return resp.data
  }
)
// [web通过mid获取用户信息] http://wiki.xunlei.cn/pages/viewpage.action?pageId=96438988
export const simpleMemberByMid = createAsyncThunk(
  'newWallet/simpleMemberByMid',
  async (arg, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post('/live/account/simple_member_by_mid', {
      ...store.getState().env.deviceinfo,
      mid: store.getState().env.deviceinfo.h_m,
    })
    return resp.data.data
  }
)

// 获取首充的banner
// http://wiki.xunlei.cn/pages/viewpage.action?pageId=155164327
export const get_recharge_count_down = createAsyncThunk(
  'newWallet/get_recharge_count_down',
  async (any: any, store: any) => {
    // 待完善 http的返回类型
    const resp = await http.post(
      '/live/activity/get_recharge_count_down',
      {
        ...any,
        ...store.getState().env.deviceinfo,
      },
      {store}
    )
    return resp.data.data
  }
)

export const first_recharge_gift = createAsyncThunk(
  'newWallet/first_recharge_gift',
  async (params: any, store: any) => {
    // return {
    //   eligible: true,
    //   gift_status: 1, // 1（可领取）、2（已领取）、3（已失效）
    // }
    const resp = await http.post('/live/merchant/first_recharge_gift', params, {
      store,
      xcErrorToast: true,
    })
    return resp.data.data
  }
)

export const send_recharge_page_of_h5_event = createAsyncThunk(
  'newWallet/send_recharge_page_of_h5_event',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/merchant/send_recharge_page_of_h5_event',
      params,
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const get_store_product_list = createAsyncThunk(
  'newWallet/get_store_product_list',
  async (params: any, store: any) => {
    const resp = await http.post('/live/pay/get_store_product_list', params, {
      store,
    })
    return resp.data.data
  }
)

// 获得月度影响力信息
export const get_monthly_influence_info = createAsyncThunk(
  'get_monthly_influence_info',
  async (any: any, store: any) => {
    const resp = await http.post(
      '/live/gift/influential_user_homepage',
      {
        ...any,
        ...store.getState().env.deviceinfo,
      },
      {store}
    )
    return resp.data.data
  }
)

export const NewHiyaWalletSlice = createSlice({
  name: 'newWallet',
  initialState,
  reducers: {
    initData: (state) => {
      Object.assign(state, initData)
    },
    updateShowGuide: (state, action: PayloadAction<boolean>) => {
      Object.assign(state.base, {
        showGuide: action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProductsList.fulfilled, (state, action) => {
      const res = action.payload
      const list = _map(res?.list, (item) => {
        return {
          ...item,
          // 列表里的currency和ThirdPartyPaySt里不一致时，用列表里的currency覆盖ThirdPartyPaySt的currency
          list: _map(item?.list, (li: any) => {
            if (li?.currency !== item?.currency) {
              li.currency = item.currency
            }
            return li
          }),
        }
      })
      // 防止已经保存的数据被完全清除
      Object.assign(state.wallet, {...res, list})
    })
    builder.addCase(getProductsList3.fulfilled, (state, action) => {
      const res = action.payload
      res.is_audit_ver = res.v_a
      // 防止已经保存的数据被完全清除
      Object.assign(state.wallet, {...res})
    })
    builder.addCase(getChipsProductList.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      const {chips} = state
      Object.assign(state, {chips: {...chips, ...data}})
    })
    builder.addCase(getChipsInfo.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      const {chips} = state
      Object.assign(state, {chips: {...chips, ...data}})
    })
    builder.addCase(simpleMemberByMid.fulfilled, (state, action) => {
      Object.assign(state.wallet, {
        baseInfo: action.payload,
      })
    })

    builder.addCase(get_banners.fulfilled, (state, action) => {
      Object.assign(state.agency, {
        banner_list: action.payload,
      })
    })
    builder.addCase(
      check_third_party_list_version.fulfilled,
      (state, action) => {
        Object.assign(state.base, {
          useNew: action.payload,
        })
      }
    )
    builder.addCase(first_recharge_gift.fulfilled, (state, action) => {
      const {eligible, gift_status} = action.payload
      Object.assign(state.base, {
        showFirstRechargeGiftPack: eligible && gift_status === 1,
      })
    })
    builder.addCase(get_recharge_count_down.fulfilled, (state, action) => {
      Object.assign(state.recharge, {
        ...action.payload,
      })
    })
    builder.addCase(get_store_product_list.fulfilled, (state, action) => {
      state.code_store = action.payload
    })
    builder.addCase(get_monthly_influence_info.fulfilled, (state, action) => {
      Object.assign(state.monthly_influence_info, {
        ...action.payload,
      })
    })
  },
})
export default NewHiyaWalletSlice.reducer
export const NewHiyaWalletAction = NewHiyaWalletSlice.actions
